import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
export default function BookingChoice() {
  const navigate = useNavigate();
  const {
    t
  } = useTranslation('crisis');
  const handleChoice = (choice: 'crisis' | 'regular') => {
    sessionStorage.setItem('booking_choice_made', 'true');
    if (choice === 'crisis') {
      navigate('/crisis-resources');
    } else {
      navigate('/service-selection');
    }
  };
  return <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-16">
        <div className="bg-gradient-to-br from-amber-50 to-orange-50 min-h-full">
          <div className="container mx-auto px-4 py-12 md:py-20">
            <div className="max-w-5xl mx-auto">
              <h1 className="text-3xl md:text-5xl font-bold text-center text-earth-800 mb-4">
                {t('choiceTitle')}
              </h1>
              

              <div className="grid md:grid-cols-2 gap-6 md:gap-8">
                {/* Crisis Button */}
                <button onClick={() => handleChoice('crisis')} className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-rose-400 to-rose-500 p-8 md:p-12 text-white shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 min-h-[300px] flex flex-col items-center justify-center">
                  <div className="absolute inset-0 bg-gradient-to-br from-rose-300/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <div className="relative z-10 flex flex-col items-center text-center space-y-6">
                    <div className="bg-white/20 backdrop-blur-sm rounded-full p-6">
                      <AlertTriangle className="h-16 w-16" />
                    </div>
                    <div>
                      <h2 className="text-2xl md:text-3xl font-bold mb-3">
                        {t('crisisButton')}
                      </h2>
                      <p className="text-rose-50 text-sm md:text-base">
                        {t('crisisDescription', 'Access immediate crisis support and emergency resources')}
                      </p>
                    </div>
                  </div>
                </button>

                {/* Regular Booking Button */}
                <button onClick={() => handleChoice('regular')} className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-indigo-400 to-indigo-500 p-8 md:p-12 text-white shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 min-h-[300px] flex flex-col items-center justify-center">
                  <div className="absolute inset-0 bg-gradient-to-br from-indigo-300/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <div className="relative z-10 flex flex-col items-center text-center space-y-6">
                    <div className="bg-white/20 backdrop-blur-sm rounded-full p-6">
                      <Calendar className="h-16 w-16" />
                    </div>
                    <div>
                      <h2 className="text-2xl md:text-3xl font-bold mb-3">
                        {t('regularButton')}
                      </h2>
                      <p className="text-indigo-50 text-sm md:text-base">
                        {t('regularDescription', 'Schedule a session with a practitioner')}
                      </p>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>;
}